import { Component, OnInit } from '@angular/core';
import { BaseCommonComponent, UserService, BaseDataService, ModalService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
// import { NotificationsService } from 'angular2-notifications';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
// import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'yt-rekapitulacija-izlaza-po-artiklima',
  templateUrl: './rekapitulacija-izlaza-po-artiklima.component.html'
})
export class RekapitulacijaIzlazaPoArtiklimaComponent extends BaseCommonComponent implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService,
    protected baseDataService: BaseDataService,
    protected translateService: TranslateService,
    protected modalService: ModalService,
    // protected notificationService: NotificationsService
    protected toastrService: NotificationService
    ) { 
    super(activatedRoute, userService, baseDataService, translateService, modalService,toastrService);
    }

    // baseFormGroup:FormGroup=new FormGroup({
    //     DatumOd:new FormControl()
    //   , DatumDo:new FormControl()
    //   , OrgJedID:new FormControl()
    //   , RobnaGrupaID:new FormControl()
    //   , ProizvodjacID: new FormControl()
    //   , KomitentID: new FormControl()
    //   , SortBy: new FormControl()
    // })
  
    // get fc() { return this.baseFormGroup.controls; }

    source = [
      { ID: 'org_jed_id', Name: 'Organizaciona jedinica' },
      { ID: 'robna_grupa_id', Name: 'Robna grupa' },
      { ID: 'dokument.komitent_id', Name: 'Komitent' },
      { ID: 'proizvodjac_id', Name: 'Proizvođač' }      
    ]

  ngOnInit() {
    super.ngOnInit();

    let dateNow = new Date();
    this.baseFormGroup = new FormGroup({
      DatumOd: new FormControl(new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, 1), [Validators.required]),
      DatumDo: new FormControl(new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate()), [Validators.required]),
      OrgJedID: new FormControl(null,[Validators.required]),
      RobnaGrupaID: new FormControl(null,[Validators.required]),
      KomitentID: new FormControl(null,[Validators.required]),
      ProizvodjacID: new FormControl(),
      SortBy: new FormControl(),
    })  

    // Validacija 
    this.addValidatorToFc('OrgJedID', Validators.required, 'required', 'REKAPITULACIJAIZLAZAPOARTIKLIMA.ORGJEDNAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc('RobnaGrupaID', Validators.required, 'required', 'REKAPITULACIJAIZLAZAPOARTIKLIMA.ROBNAGRUPANAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc('KomitentID', Validators.required, 'required', 'REKAPITULACIJAIZLAZAPOARTIKLIMA.KOMITENTNAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc('ProizvodjacID', Validators.required, 'required', 'REKAPITULACIJAIZLAZAPOARTIKLIMA.PROIZVODJACNAZIV.VALIDATION.REQUIRED');
  }

  sortByItemSelected(item){
  }

}

